import './ConfigurationUpdate.css';

import React, { useState } from 'react';

import { Button, Form, Header, Icon, Modal, Radio } from 'semantic-ui-react';


const ConfigurationUpdate = ({ configuration, profile, handleSubmit }) => {

    const [modalOpen, setModalOpen] = useState(false);
    const [ant_type, setAntennaType] = useState(configuration.ant_type);
    const [channel_bandwidth, setChannelBandwidth] = useState(configuration.channel_bandwidth);

    const channelBandwidths = [
        [0, '1.4'],
        [1, '3'],
        [2, '5'],
        [3, '10'],
        [4, '15'],
        [5, '20'],
    ];

    const handleSave = (e) => {
        handleSubmit(e);
        setModalOpen(false);
    }

    return (
        <Modal
            className="modal configurationupdate"
            closeIcon={{ style: { top: '1.0535rem', right: '1rem' }, color: 'black', name: 'close' }}
            trigger={<Button icon
                onClick={() => setModalOpen(true)}
                data-tooltip="Update the current configuration"
                data-inverted=""
                data-tut="reactour__configuration__update"
            ><Icon name='edit' />

            </Button>}
            open={modalOpen}
            onClose={() => setModalOpen(false)}
        >
            <Header icon='settings' content='Update Configuration' />
            <Modal.Content>
                <Form onSubmit={handleSave}>

                    <Form.Group inline>
                        <Form.Field>
                            <label>Antenna gain (dBi)</label>
                            <input id="ant_gain"
                                placeholder={configuration.ant_gain}
                                defaultValue={configuration.ant_gain}
                                type="number"
                            />
                        </Form.Field>
                    </Form.Group>

                    <div className="ui segment">
                        <Form.Group inline>
                            <Form.Field>
                                <label>Base station antenna height ({profile.units_length_string})</label>
                                <input id="bts_ht"
                                    defaultValue={configuration.bts_ht_local}
                                    type="text" pattern="[0-9]*"
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>Override antennas height</label>
                                <input id="bts_ht_override"
                                    type="checkbox"
                                    defaultChecked={configuration.bts_ht_override}
                                />
                            </Form.Field>
                        </Form.Group>
                    </div>

                    <div className="ui segment">
                        <Form.Group inline>
                            <Form.Field>
                                <label>Transmit power ({profile.units_power_string})</label>
                                <input id="txpwr"
                                    defaultValue={configuration.txpwr_local}
                                    type="text" pattern="[0-9]*"
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>Override transmit power</label>
                                <input id="txpwr_override"
                                    type="checkbox"
                                    defaultChecked={configuration.txpwr_override}
                                />
                            </Form.Field>
                        </Form.Group>
                    </div>

                    <Form.Field>
                        <label>Frequency in MHz (20 MHz to 20 GHz)</label>
                        <input id="fr"
                            placeholder={configuration.fr}
                            defaultValue={configuration.fr}
                            type="number"
                        />
                    </Form.Field>

                    <Form.Group inline>
                        <Form.Field>
                            <label>Max coverage range (km)</label>
                            <input id="max_range"
                                placeholder={configuration.max_range}
                                defaultValue={configuration.max_range}
                                type="number"
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Buffer distance (km)</label>
                            <input id="buffer_distance"
                                placeholder={configuration.buffer_distance}
                                defaultValue={configuration.buffer_distance}
                                type="number"
                            />
                        </Form.Field>
                    </Form.Group>

                    <div className="ui segment">
                        <Form.Group inline>
                            <Form.Field>
                                <label>Is sectored antenna?</label>
                                <input id="is_sector"
                                    type="checkbox"
                                    defaultChecked={configuration.is_sector}
                                />
                            </Form.Field>
                        </Form.Group>

                        <Form.Group inline>
                            <label>Antenna Type</label>
                            <Form.Field>
                                <Radio
                                    label='GSM'
                                    name='radioAntennaType'
                                    value={0}
                                    checked={ant_type === 0}
                                    onChange={() => setAntennaType(0)}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Radio
                                    label='UMTS'
                                    name='radioAntennaType'
                                    value={1}
                                    checked={ant_type === 1}
                                    onChange={() => setAntennaType(1)}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Radio
                                    label='LTE'
                                    name='radioAntennaType'
                                    value={2}
                                    checked={ant_type === 2}
                                    onChange={() => setAntennaType(2)}
                                />
                            </Form.Field>

                        </Form.Group>

                        <Form.Group inline hidden={ant_type !== 2}>
                            <label>Channel Bandwidth (MHz)</label>

                            {channelBandwidths.map(cb =>
                                <Form.Field key={cb[1]}>
                                    <Radio
                                        label={cb[1]}
                                        name='radioChannelBandwidth'
                                        value={cb[0]}
                                        checked={channel_bandwidth === cb[0]}
                                        onChange={() => setChannelBandwidth(cb[0])}
                                    />
                                </Form.Field>
                            )
                            }

                        </Form.Group>

                        <Form.Field
                            hidden={ant_type !== 1}
                        >
                            <label>Allocated CPICH (dBm)</label>
                            <input id="allocated_cpich"
                                placeholder={configuration.allocated_cpich}
                                defaultValue={configuration.allocated_cpich}
                                type="number"
                            />
                        </Form.Field>
                    </div>

                    <Modal.Actions>
                        <Button color='green' >
                            <Icon name='checkmark' />Save
                            </Button>
                    </Modal.Actions>
                </Form>
            </Modal.Content>
        </Modal >
    )

}

export default ConfigurationUpdate;